import styled from "@emotion/styled";
import { fontPlayfairDisplay } from "@product/scmp-sdk";

export const CardTitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  margin-block: 12px 0;
  margin-inline: auto;
`;

export const CardTitleWord = styled.div`
  color: #fbfbfb;
  font-weight: 400;
  font-size: 24px;
  font-family: ${fontPlayfairDisplay};
  line-height: 30px;
  text-align: center;
`;
